import { IoClose } from 'react-icons/io5';
import { RiContactsBook2Line } from 'react-icons/ri';
import { Avatar } from '../../../../components';

const SelectedItem = ({ item, onRemove, type = 'contact' }) => {
    const isContact = type === 'contact' || item?.number_client;
    
    return (
        <li>
            <span className='avatar--'>
                {isContact ? (
                    <Avatar 
                        name={item?.name} 
                        width={'100%'} 
                        height={'100%'} 
                        fontSize={'1.5rem'} 
                    />
                ) : (
                    <span className='avatar--list'>
                        <RiContactsBook2Line />
                    </span>
                )}
            </span>
            <span className='info--'>
                <span className='name'>
                    {item?.nome ? item.nome : item.name}
                </span>
                <span className='description'>
                    {isContact 
                        ? item?.number_client 
                        : (item?.descricao ? item?.descricao : '...')
                    }
                </span>
            </span>
            <span className='icon' onClick={() => onRemove(item)}>
                <IoClose />
            </span>
        </li>
    );
};

export default SelectedItem;